export enum StorageKey {
  AUTH_TOKEN_KEY = 'auth_token',
  GUEST_TOKEN_KEY = 'guest_token',
  IS_RELOADED_KEY = 'is_reloaded',
  EVENT_LIST_VIEW_TYPE_KEY = 'event_list_view_type'
}
